import { RootState } from "@stores";
import { PreferenceSliceState } from "@stores/preference/slices.ts";
import { useSelector } from "react-redux";

const usePreference = () => {
  return useSelector<RootState, PreferenceSliceState>((state) => state.preferences);
};

export default usePreference;
